<template lang="pug">
  .text-xs-center
    y-bottom-sheet(v-if="$vuetify.breakpoint.xsOnly" v-model='showModal' inset max-width="600px")
      v-card.grey.lighten-3
        v-row.px-3.pb-3(align="center")
          v-col.py-0
            .subheading.pt-3(style='min-height:24px;') {{displayFormula}}
            div(:class="[displayResult.length > 15 ? displayResult.length > 20 ? 'headline':'display-1':'display-2']" style='min-height:48px;') {{displayResult}}
          v-col.shrink
            v-btn.my-auto.mr-4.info(depressed fab width=46 height=46 @click='commit')
              v-icon mdi-keyboard-return
        v-card-text.pa-0
          v-container.white(grid-list-xs)
            v-layout(row='' wrap='' pa0='')
              v-flex(v-for='button in buttons' :key='button.key' xs3='')
                v-btn(:class="['ma-0', 'calcbutton', button.class]" :color='button.color' @click='inputKey(button.key)' block='' depressed='' large='')
                  v-icon(v-if='button.icon' dark='') {{button.icon}}
                  template(v-else='') {{button.label}}
    y-dialog(v-else v-model='showModal' max-width="450px")
      v-card.grey.lighten-3
        v-row.pa-3(align="center")
          v-col.py-0
            .subheading.pt-3(style='min-height:24px;') {{displayFormula}}
            div(:class="[displayResult.length > 15 ? displayResult.length > 20 ? 'headline':'display-1':'display-2']" style='min-height:48px;') {{displayResult}}
          v-col.shrink
            v-btn.my-auto.mr-4.info(depressed fab width=46 height=46 @click='commit')
              v-icon mdi-keyboard-return
        v-card-text.pa-0
          v-container.white(grid-list-xs)
            v-layout(row='' wrap='' pa0='')
              v-flex(v-for='button in buttons' :key='button.key' xs3='')
                v-btn(:class="['ma-0', 'calcbutton', button.class]" :color='button.color' @click='inputKey(button.key)' block='' depressed='' large='')
                  v-icon(v-if='button.icon' dark='') {{button.icon}}
                  template(v-else='') {{button.label}}
</template>

<script>

export default {
  name: 'CalculatorInputDialog',
  props: ['open', 'initial'],
  data: vm => ({
    input: { 
      current: vm.initial? (vm.initial/vm.$currency.multiplier).toString() : "0",
      operator: "",
      prev: "",
    },
    buttons: [
      { key: "ce", label: "CE", color: "grey lighten-2", class: "" },
      { key: "c", label: "C", color: "grey lighten-2", class: "" },
      {
        key: "back",
        label: "BACK",
        icon: "mdi-backspace",
        color: "grey lighten-2",
        class: "",
      },
      { key: "÷", label: "÷", color: "grey lighten-2", class: "" },
      { key: "7", label: "7", color: "white", class: "headline" },
      { key: "8", label: "8", color: "white", class: "headline" },
      { key: "9", label: "9", color: "white", class: "headline" },
      { key: "×", label: "×", color: "grey lighten-2", class: "" },
      { key: "4", label: "4", color: "white", class: "headline" },
      { key: "5", label: "5", color: "white", class: "headline" },
      { key: "6", label: "6", color: "white", class: "headline" },
      { key: "-", label: "-", color: "grey lighten-2", class: "" },
      { key: "1", label: "1", color: "white", class: "headline" },
      { key: "2", label: "2", color: "white", class: "headline" },
      { key: "3", label: "3", color: "white", class: "headline" },
      { key: "+", label: "+", color: "grey lighten-2", class: "" },
      { key: "00", label: "00", color: "white", class: "headline" },
      { key: "0", label: "0", color: "white", class: "headline" },
      { key: ".", label: ".", color: "grey lighten-2", class: "" },
      { key: "=", label: "=", color: "grey lighten-2", class: "" },
    ]
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    displayResult () {
      const hasDot = this.input.current.includes(".");
      const split = this.input.current.split(".");
      const integer = Number(split[0]);
      const minority = split[1];
      // return this.input.current;
      return `${integer.toLocaleString()}${hasDot ? "." + minority : ""}`;
    },
    displayFormula () {
      return `${this.input.prev} ${this.input.operator}`;
    }
  },
  mounted () {
    window.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode === 13) {
        this.commit()
      } else if (charCode === 190) {
        this.inputKey(".")
      } else if (charCode === 191) {
        this.inputKey("÷")
      } else if (evt.shiftKey && charCode === 56) {
        this.inputKey("×")
      } else if (charCode === 189) {
        this.inputKey("-")
      } else if (evt.shiftKey && charCode === 187) {
        this.inputKey("+")
      } else if (charCode === 187) {
        this.inputKey("=")
      } else if (charCode === 8) {
        this.inputKey("back")
      } else if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        this.inputKey(String.fromCharCode(charCode))
        return true;
      }
    },
    inputKey (key) {
      const isNumber = /^\d$/.test(key);
      if (isNumber || (this.input.current !== "0" && key === "00")) {
        if (this.input.current.length >= 12) {
          return;
        }
        if (this.input.current !== "0") {
          this.input.current += key;
        } else {
          this.input.current = key;
        }
        return;
      }

      const isOperator = /^[÷×\-+]$/.test(key);
      if (isOperator) {
        if (this.input.current) {
          this.input.prev = this.calculate(this.input) || this.input.current;
        }
        this.input.operator = key;
        this.input.current = "";
        return;
      }

      switch (key) {
        case "=": {
          if (this.input.operator) {
            const result = this.calculate(this.input) || "";
            this.input.prev = `${this.input.prev} ${this.input.operator} ${
              this.input.current
            } =`;
            this.input.current = result;
            this.input.operator = "";
          }
          return;
        }

        case ".":
          if (!this.input.current.includes(".")) {
            this.input.current += ".";
          }
          return;
        case "±":
          if (this.input.current.includes("-")) {
            this.input.current = this.input.current.replace("-", "");
          } else {
            this.input.current = "-" + this.input.current;
          }
          return;
        case "back":
          this.input.current =
            this.input.current.substring(0, this.input.current.length - 1) || "0";
          return;
        case "c":
          this.input.current = "0";
          this.input.operator = "";
          this.input.prev = "";
          return;
        case "ce":
          this.input.current = "0";
          return;
      }
    },
    calculate (input) {
      const a = Number(input.prev);
      const b = Number(input.current);
      let result = null
      switch (input.operator) {
        case "÷": 
          result = (a / b)
          break
        case "×":
          result = (a * b)
          break
        case "-":
          result = (a - b)
          break
        case "+":
          result = (a + b)
          break
      }
      if (!result) {
        return null
      }
      const resultString = result.toString();
      if (resultString.includes('.') && resultString.split(".")[1].length > 2) {
        return result.toFixed(this.$currency.exponent);
      }
      return resultString;
    },
    commit () {
      this.inputKey("=")
      this.$emit("input", this.input.current)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "proceed": "Proceed"
  }
}
</i18n>
